import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Box, Stack } from "@towersystems/towersystems-design-system";
import { getCubes } from "state/graph-cube/selectors";
import { map, noop } from "lodash";
import { Text } from "components/text";
import FormMultiCheckbox from "components/forms/form-multi-checkbox";
import { getCurrentPath } from "state/ui/selectors";
import "./styles.scss";

const ReportFilters = ({
  onChange = noop,
  cubes,
  currentPath,
  defaultDataSetFilters = [],
  defaultDataTypeFilters = [],
}) => {
  const [dataSetFilters, setDataSetFilters] = useState(defaultDataSetFilters);
  const [dataTypeFilters, setDataTypeFilters] = useState(
    defaultDataTypeFilters,
  );

  useEffect(() => {
    onChange({ dataTypeFilters, dataSetFilters });
  }, [dataTypeFilters, dataSetFilters]);

  let cubeOptions = map(cubes, ({ name }) => ({
    value: name,
    label: name,
  }));

  let dataTypeOptions = [
    { value: "trends", label: "Trend" },
    { value: "single_data", label: "Single data" },
    { value: "time_series", label: "Time series" },
  ];

  return (
    <Box>
      <Stack className="reports__filters" space="xlarge">
        <Text
          fullWidth
          variant="headingXxs"
          transform="uppercase"
          decoration="dotted"
        >
          Data set
        </Text>
        <FormMultiCheckbox
          defaultChecked={defaultDataSetFilters}
          onChange={setDataSetFilters}
          options={cubeOptions}
        />

        <Text
          fullWidth
          variant="headingXxs"
          transform="uppercase"
          decoration="dotted"
        >
          Data type
        </Text>
        <FormMultiCheckbox
          defaultChecked={defaultDataTypeFilters}
          onChange={setDataTypeFilters}
          options={dataTypeOptions}
        />
      </Stack>
    </Box>
  );
};

export default connect((state) => ({
  cubes: getCubes(state),
  currentPath: getCurrentPath(state),
}))(ReportFilters);
